const PageTitle = ({ children }) => {
  return (
    <h1 className="head-alt-md md:head-alt-lg max-w-5xl mb-8 text-center md:text-left">
      {children}
    </h1>
  );
};

export default PageTitle;
